import { DEALERS_INSIGHTS_LEVELS } from './constants';

/**
 * @typedef {'network'|'dealer'} DealerInsightsLevel
 */

/**
 * @typedef {Object} LevelData
 * @property {DealerInsightsLevel} currentLevel
 * @property {{id: string, name: string}} [currentDealer]
 */

/**
 * @constant levelInitialState
 * @type {LevelData}
 */
const levelInitialState = {
  currentLevel: DEALERS_INSIGHTS_LEVELS.NETWORK,
  currentDealer: {
    id: null,
    name: null,
  },
};

export const defaultState = () => levelInitialState;
